import config from '../../config';

// A function, not a constant: in Solvie the settings only exist once Cato's pane has mounted
export const getCassiePwaProtocolUrl = (): string => config.cassieWebsocketProtocol;
